import { useContext } from "react";
import useErrorHandler from "@beeldit/core/errors/useErrorHandler";
import get from "@beeldit/core/services/get";
import { CancelActionContext } from "./CancelActionContext";

function useCancel() {
  const { elementId, setShowModal } =
    useContext(CancelActionContext);
  const errorHandler = useErrorHandler();
  return (onSuccess: any) => {
    get("super-orders/cancel", elementId)
      .then((response: any) => {
        setShowModal(false);
        onSuccess();
      })
      .catch((error: any) => {
        errorHandler(error);
      });
  };
}

export default useCancel;
